const PropertyIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={32}
    height={32}
    viewBox='0 0 32 32'
    fill='none'
    {...props}>
    <path
      stroke='currentColor'
      strokeMiterlimit={10}
      strokeWidth={1.08}
      d='M26.614 27.117V16.822h3.108v-2.71L16.11 2.5 2.5 14.112v2.71h3.108v10.295'
    />
    <path
      stroke='currentColor'
      strokeMiterlimit={10}
      strokeWidth={1.08}
      d='M26.614 16.815 16.108 7.848 5.602 16.815M12.902 27.119v-7.89h6.61v7.89M2.742 29.305h26.74'
    />
  </svg>
)

export default PropertyIcon
